import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("w4tchlist", "W4tchList", "img/projects/w4tchlist-1.png", `
      <div class="paragraph">
        <strong>W4tchList</strong> is an android app that allows you to create lists of movies and share it with your friends.. with a small tweak, the users you share the list with will also be able to edit it completely.
      </div>

      <div class="paragraph">
        This is the first app I developed, made in 1 month for a university project.
        <br><br>      
        Main features :
        <ul>
        <li>Android App made in Kotlin with Android Studio</li>
        <li>Uses TMDB API for its functionality</li>
        <li>Uses Firebase for everything related to database and user auth</li>
        </ul>
        <div class="notice">
          Android apk and source code available on <a href="https://github.com/niiK0/w4tchlist" target="_blank">GitHub</a>.
        </div>
      </div>

      <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/w4tchlist-1.png" alt="W4tchList Screenshot" />
        <img class="pc-screenshot" src="img/projects/w4tchlist-2.png" alt="W4tchList Screenshot" />
        <img class="pc-screenshot" src="img/projects/w4tchlist-3.png" alt="W4tchList Screenshot" /> 
      </div>
    `, "#c10606", true, false),
];